// Sentry and PostHog must initialize before React renders so the SDKs can
// capture render-time errors and identify the page view.

import React from "react";
import { posthog } from "./sentry";
import "react-datepicker/dist/react-datepicker.css";
import { signOut as firebaseSignOut } from "firebase/auth";
import { WebStorageStateStore } from "oidc-client-ts";
import { PostHogProvider } from "posthog-js/react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { OidcSessionBridge } from "./components/OidcSessionBridge/OidcSessionBridge";
import { keycloakConfig } from "./config";
import { auth } from "./Firebase";
import UserContextWithLogin from "./UserContextWithLogin";
import "./css/AlbertineColors.css";
import "./css/AlbertineTypography.css";
import "./css/index.css";
import "./css/react-datepicker-override.css";
import { TooltipProvider } from "./components/ui/tooltip";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <PostHogProvider client={posthog}>
            <AuthProvider
                authority={keycloakConfig.authority}
                client_id={keycloakConfig.clientId}
                redirect_uri={keycloakConfig.redirectUri}
                userStore={new WebStorageStateStore({ store: window.localStorage })}
                accessTokenExpiringNotificationTimeInSeconds={60}
                // Renew is driven by OidcSessionBridge instead so it can take
                // a cross-tab Web Lock (Keycloak's refresh-token rotation
                // would otherwise kill the session if two tabs race) and
                // retry transient failures before redirecting.
                automaticSilentRenew={false}
                onSigninCallback={() => {
                    // Remove OIDC query params from the URL after redirect.
                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname,
                    );
                }}
                onRemoveUser={async () => {
                    if (auth.currentUser) {
                        await firebaseSignOut(auth);
                    }
                }}
            >
                <OidcSessionBridge />
                <TooltipProvider>
                    <BrowserRouter>
                        <Switch>
                            <Route component={UserContextWithLogin} />
                        </Switch>
                    </BrowserRouter>
                </TooltipProvider>
            </AuthProvider>
        </PostHogProvider>
    </React.StrictMode>,
);
